<template>
  <div class="vx-row">
    <div class="vx-col md:w-4/4 w-full mb-base">
      <vx-card title="Device Info">
        <div class="w-full flex flex-wrap">
          <div class="w-full">
            <div class="w-full flex flex-no-wrap">
              <div class="w-1/4 p-4 pt-6">
                Device Type Name
                <span class="text-danger">*</span>
              </div>
              <div class="w-3/4 p-4">
                <vs-input
                  id="txt-device-type-name"
                  class="w-full"
                  placeholder="Name"
                  v-model="name"
                  name="device type name"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('device type name')"
                >{{ errors.first('device type name') }}</span>
              </div>
            </div>
            <vs-divider>
              <span class="uppercase">Device Profile Properties</span>
            </vs-divider>
            <div class="w-full flex flex-no-wrap">
              <div class="w-4/5 flex flex-no-wrap">
                <div class="w-1/4 p-4">
                  <vs-input id="txt-profile-property" class="w-full" placeholder="Property" v-model="temp_profile.key" />
                <!--  <span
                    class="text-danger text-sm"
                    v-show="temp_profile.key === '' "
                  >Please fill this property</span>-->
                </div>
                <div class="w-3/4 flex flex-no-wrap">
                  <div class="w-2/5 p-4">
                    <vs-select
                      v-model="propertyType"
                      placeholder="Type"
                      class="w-full mb-4 no-icon-border">
                      <vs-select-item
                              :key="index"
                              :value="item.id"
                              :text="item.label"
                              v-for="(item,index) in propertyTypes"/>
                    </vs-select>
                  </div>
                  <div class="w-3/5 p-4">
                    <vs-input id="txt-profile-value" v-bind:type="propertyType" class="w-full" placeholder="Value" v-model="temp_profile.value" />
                  </div>
                 <!-- <span
                    class="text-danger text-sm"
                    v-show="temp_profile.value === '' "
                  >Please fill this value</span>-->
                </div>
              </div>

              <div class="w-1/5 p-4">
                <vs-button
                  id="btn-add-profile"
                  class="mr-3 w-full"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="addProfile"
                >Add Profile</vs-button>
              </div>
            </div>
            <div class="w-full flex flex-wrap" v-if="profiles.length > 0">
              <div class="w-4/5 flex flex-no-wrap">
                <div class="w-2/4 px-4 py-0"> <h3>Profile Added</h3></div>
                <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
              </div>
              <div class="w-4/5 flex flex-no-wrap">
                <div class="w-2/4 px-4 py-0"> </div>
                <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
              </div>
            </div>
            <div class="w-full flex flex-wrap" :key="ind" v-for="(data, ind) in profiles">
              <div class="w-4/5 flex flex-no-wrap">

                <div class="w-1/4 px-4 py-0">{{data.key}}</div>
                <div class="w-3/4 px-4 py-0 flex flex-wrap">
                  <span class="w-4/5">{{data.value}}</span>
                  <span class="w-1/5 text-right">
                    <feather-icon
                      icon="Trash2Icon"
                      svgClasses="h-5 w-5"
                      class="cursor-hand"
                      @click="deleteProfile(ind)"
                    />
                  </span>
                </div>
              </div>
              <div class="w-1/5 p-4"></div>
              <div class="w-4/5" v-if="ind!=profiles.length-1">
                <vs-divider />
              </div>
            </div>
            <span class="w-full mb-10" />
            <div>
              <vs-divider>
                <span class="uppercase">Payment channel default properties</span>
              </vs-divider>
              <div class="w-full flex flex-wrap">
                <div class="w-4/5 flex flex-no-wrap">
                  <div class="w-1/4 p-4 pt-6">Payment Channel</div>
                  <div class="w-3/4 p-4">
                      <v-select id="cbo-payment-channel" v-model="selected_channel" placeholder="Select payment channel" :options="payment_channel_list"></v-select>
                  </div>
                </div>
                <div class="w-1/5 p-4">
                  <vs-button
                    id="btn-add-payment-channel"
                    class="mr-3 w-full"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="addPaymentChannel"
                  >Add Channel</vs-button>
                </div>
                <span class="w-full mb-6" />
                <vx-card
                  class="w-full mb-6"
                  :title="data.name"
                  collapse-action
                  remove-card-action
                  @remove="deleteChannel(index)"
                  :key="index"
                  v-for="(data, index) in channels"
                >
                  <div class="w-full flex flex-no-wrap">
                    <div class="w-4/5 p-4">
                      <vs-input v-bind:id="'txt-property-name-'+index" class="w-full" placeholder="Name" v-model="temp_prop[index]" />
                    </div>
                    <div class="w-1/5 p-4">
                      <vs-button
                        v-bind:id="'btn-add-property-'+index"
                        class="mr-3 mb-2"
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="addProp(index)"
                      >Add Property</vs-button>
                    </div>
                  </div>
                  <div class="w-full flex flex-wrap" v-if="channels[index].prop.length > 0">
                    <div class="w-4/5 flex flex-no-wrap">
                      <div class="w-2/4 px-4 py-0"> <h3>Payment Channel Added</h3></div>
                      <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
                    </div>
                    <div class="w-4/5 flex flex-no-wrap">
                      <div class="w-2/4 px-4 py-0"> </div>
                      <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
                    </div>
                  </div>
                  <div
                    class="w-full flex flex-wrap"
                    :key="ind"
                    v-for="(data, ind) in channels[index].prop"
                  >
                    <div class="w-4/5 p-4 flex flex-wrap">
                      <div class="w-full px-4 py-0 flex flex-wrap">
                        <span class="w-4/5">{{data}}</span>
                        <span class="w-1/5 text-right">
                          <feather-icon
                            icon="Trash2Icon"
                            svgClasses="h-5 w-5"
                            class="cursor-hand"
                            @click="deleteProp(index,ind)"
                          />
                        </span>
                      </div>
                      <div class="w-full" v-if="ind!=channels[index].prop.length-1">
                        <vs-divider />
                      </div>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <vx-card>
      <div class="w-full text-right">
        <vs-button id="btn-cancel" type="border" @click="backPage">Cancel</vs-button>
        <vs-button id="btn-submit" class="ml-4" @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import AxiosCall from "@/global/AxiosCall";
import vSelect from 'vue-select'
import { url } from "@/configs/apiUrl";
export default {
  name: "deviceType",
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      name: "",
      activeLoading: false,
      temp_profile: {
        key: "",
        value: ""
      },
      payment_channel_list: [],
      selected_channel: "",
      channels: [],
      profiles: [],
      temp_prop: [],
      propertyTypes: [
        {id: "text", label: "String"},
        {id: "number", label: "Number"}
      ],
      propertyType: "text"
    };
  },
  methods: {
    backPage() {
      this.$router.push({
        name: "DeviceTypeList",
        params: { status: status, message: "add" }
      });
    },
    addProfile() {
      if (this.temp_profile.key !== "" && this.temp_profile.value !== ""){
        if(this.profiles.some(profile => profile.key === this.temp_profile.key)){
          this.warning("Warning", "Property already exist, please input other property")
        } else{
          let tempProfileValue
          if (this.propertyType === "number") {
            tempProfileValue = Number(this.temp_profile.value)
          } else {
            tempProfileValue = this.temp_profile.value
          }
          this.profiles.push({
            key: this.temp_profile.key,
            value: tempProfileValue
          });
          this.temp_profile.key = "";
          this.temp_profile.value = "";
        }


      }else{
        if (this.temp_profile.key === ""){
          this.warning("Warning", "Please input property!");
        }

        if (this.temp_profile.value === ""){
          this.warning("Warning", "Please input value!");
        }
      }

    },
    deleteProfile(index) {
      this.profiles.splice(index, 1);
    },
    validateForm(){
      return (
              !this.errors.any() &&
              this.name !== ""
      )
    },
    onChangeChannel(value) {
      this.selected_channel = value;
    },
    addPaymentChannel() {
      if (this.selected_channel !== null && this.selected_channel !== "") {
        let checkDataChannelIsExist = this.channels.filter(obj => {
          return obj.id === this.selected_channel.id;
        });

        if (checkDataChannelIsExist.length > 0) {
          this.$vs.notify({
            title: "Payment Channel Config",
            text: "Payment Channel already added",
            color: "danger",
            position: "top-right"
          });
        } else {
          let channelObj = this.payment_channel_list.filter(obj => {
            return obj.id === this.selected_channel.id;
          });
          this.temp_prop.push("");
          this.channels.push({
            name: channelObj[0].name,
            id: channelObj[0].id,
            prop: []
          });
          // console.log(this.channels)
        }
        this.selected_channel = "";
      } else {
        this.$vs.notify({
          title: "Payment Channel not selected",
          text: "Please select a payment channel",
          color: "warning",
          position: "top-right"
        });
      }
      //   console.log(this.selected_channel);
    },
    deleteChannel(index){
      this.channels.splice(index, 1)
    },
    addProp(index) {
       if (this.temp_prop.length > 0){
           if (this.temp_prop[index] !== ""){
             if (!this.channels[index].prop.includes(this.temp_prop[index])){
               this.channels[index].prop.push(this.temp_prop[index]);
               this.temp_prop[index] = "";
             }else{
               this.warning("Warning", "Property name already exist!");
             }

           }else{
               this.warning("Warning", "Please input name!");
           }
       }else{
           this.warning("Warning", "Please input name!");
       }


    },
    deleteProp(indexIss, idxProp) {
      this.channels[indexIss].prop.splice(idxProp, 1);
    },
    warning(title, text) {
      this.$vs.notify({
        title: title,
        text: text,
        color: "warning",
        position: "top-right"
      });
    },
    danger(text) {
      this.$vs.notify({
        title: "Failed",
        text: text,
        color: "danger",
        position: "top-right"
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "radius"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    submitForm(e) {
      console.log("submitForm");
      e.preventDefault();
      this.$validator.validateAll().then(result => {
        if (result) {
          /*if (this.profiles.length > 0) {*/
            /*if (this.channels.length > 0) {*/
              this.openLoading();
              let profile = {};
              for (let i in this.profiles) {
                let key = this.profiles[i].key;

                let obj = { [key]: this.profiles[i].value };
                Object.assign(profile, obj);
              }

              let configs = {};
              for (let i in this.channels) {
                let key = this.channels[i].name;
                let obj = { [key]: this.channels[i].prop };
                Object.assign(configs, obj);
              }

             /* if (Object.keys(configs).length > 0) {*/
                let user = JSON.parse(localStorage.getItem("userInfo"))
                  .displayName;

                let data = {
                  name: this.name,
                  profile: profile,
                  config: configs,
                  user_action: user
                };
                let id = this.$route.query.id;
                if (id !== undefined) {
                  AxiosCall.Put(url.svd.device_type.update + "/" + id, data)
                    .then(resp => {
                      if (resp.code == 200) {
                        this.closeLoading();
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Type",
                            activity: "Update Device Type",
                            data_before: this.$store.state.current_device_data,
                            data_after: data,
                        })
                        let status = true;
                        this.$router.push({
                          name: "DeviceTypeList",
                          params: { status: status, message: "update" }
                        });
                      } else {
                        this.closeLoading();
                        this.danger("Update device type fail");
                      }
                    })
                    .catch(e => {
                      this.closeLoading();
                      console.log(e);
                      this.danger("Update device type fail");
                    });
                } else {
                  AxiosCall.Post(url.svd.device_type.store, data)
                    .then(resp => {
                      if (resp.code == 200) {
                        this.closeLoading();
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Type",
                            activity: "Add Device Type",
                            data_before: {},
                            data_after: data,
                        })
                        let status = true;
                        this.$router.push({
                          name: "DeviceTypeList",
                          params: { status: status, message: "add" }
                        });
                      } else {
                        this.closeLoading();
                        this.danger("Create device type fail");
                      }
                    })
                    .catch(e => {
                      this.closeLoading();
                      console.log(e);
                      this.danger("Create device type fail");
                    });
                }
            /*  } else {
                this.warning("Channels", "Please add property of channel");
              }*/
           /* } else {
              this.warning("channels", "Please select channels");
            }*/
        /*  } else {
            this.warning("Profile", "Please fill profile");
          }*/
        }else{
          if (!this.validateForm()){
            this.warning("Warning", "Please input all required fields!");
          }
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.id !== undefined) {
      AxiosCall.Get(
        url.svd.device_type.detail + "/" + this.$route.query.id
      ).then(response => {
        if (response.code === 200) {
          this.name = response.data.name;
          this.$store.commit("UPDATE_CURRENT_DEVICE_DATA", response.data)
          for (let key in response.data.profile) {
            this.profiles.push({ key: key, value: response.data.profile[key] });
          }

          let no = 0;
          for (let i in response.data.config) {
            this.channels.push({
              name: i,
              id: no,
              prop: response.data.config[i]
            });
            no++;
          }
        }
      });
    }
  },
  created() {
    AxiosCall.Get(url.svd.payment_channel.list_selection).then(resp => {

      for (let data of resp.data){
        data.label = data.name
        this.payment_channel_list.push(data)
      }
    });
  },
  watch: {
    propertyType: function(val) {
      if (val === "number" || val === "text") {
        this.temp_profile.value = ""
      }
    }
  }
};
</script>

<style scoped>
</style>